import React from 'react';
import { Button, Text } from '@carnica/ui-kit';
import { IconUserFilled } from '@carnica/graphics';
import classNames from 'classnames/bind';
import { LOGIN_TEXT } from "./consts";
import Avatar from "./assets/avatar.svg";
import AvatarFilled from "./assets/avatar-filled.svg";
import AvatarDark from "./assets/avatar-dark.svg";
import { Metric } from "../../metric";
import { EHeaderTheme, HeaderThemeView } from "../../store/slices/layout";
import { useBreakpointContext } from "../../../../components/BreakpointProvider";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Login = function Login(_ref) {
  var user = _ref.user,
    headerTheme = _ref.headerTheme,
    onClick = _ref.onClick;
  var _useBreakpointContext = useBreakpointContext(),
    isDesktop = _useBreakpointContext.isDesktop;
  if (isDesktop) return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: user ? user.accountText : LOGIN_TEXT,
    events: {
      headerMetric: ['handleTopButtonClick']
    },
    mode: "click",
    "data-t-id": "components-Login"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('login-button', {
      'login-button--with-user': user
    }),
    onClick: onClick,
    size: "m",
    view: user ? HeaderThemeView[headerTheme] : 'primary',
    "data-t-id": "components-Login"
  }, user ? /*#__PURE__*/React.createElement(Text, {
    className: cn('login-text'),
    color: headerTheme === EHeaderTheme.dark ? 'primary-invert' : 'primary',
    size: "xs",
    weight: "medium"
  }, /*#__PURE__*/React.createElement(Avatar, {
    "data-t-id": "components-Login"
  }), user.accountText) : LOGIN_TEXT));
  return user ? /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: user.accountText,
    events: {
      headerMetric: ['handleTopButtonClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('login-button--only-icon'),
    mode: "inline",
    onClick: onClick,
    "data-t-id": "components-Login"
  }, headerTheme === EHeaderTheme.dark ? /*#__PURE__*/React.createElement(AvatarDark, null) : /*#__PURE__*/React.createElement(AvatarFilled, null))) : /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: LOGIN_TEXT,
    events: {
      headerMetric: ['handleTopButtonClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    iconLeft: IconUserFilled,
    onClick: onClick,
    onlyIcon: true,
    size: "m",
    view: HeaderThemeView[headerTheme],
    "data-t-id": "components-Login"
  }));
};